import { sizeOptions, variantOptions } from "#ce/components/SpButton/props";
import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * Initial expanded state. Two-way via update-expanded event.
   *
   * @type {Boolean|String}
   * @default false
   */
  expanded: booleanAttribute(),
  /**
   * Activator label shown when the list is expanded.
   *
   * @type {String}
   * @default "Show less"
   */
  expandedTitle: {
    type: String,
    default: "Show less",
  },
  /**
   * Maximum number of items to display when collapsed. Items past this index are hidden via a sibling modifier class on the slotted children. When undefined or 0 the list shows everything and no activator renders.
   *
   * @type {Number}
   * @default undefined
   * @storybook-control number
   */
  limit: {
    type: Number,
    default: undefined,
  },
  /**
   * Number of grid columns. When undefined the list renders as a single column.
   *
   * @type {Number}
   * @default undefined
   * @storybook-control number
   */
  columns: {
    type: Number,
    default: undefined,
  },
  /**
   * Visual variant of the activator button (an sp-button variant). "text-inline" reads as an inline link; "outlined" gives the activator a bordered button look; "flat" / "text" map to the matching sp-button variants.
   *
   * @type {String}
   * @default "text-inline"
   * @storybook-control select
   */
  variant: {
    type: String,
    default: "text-inline",
    validator: (value) => variantOptions.includes(value),
  },
  /**
   * Size of the activator button, forwarded to the underlying sp-button (an sp-button size).
   *
   * @type {String}
   * @default "default"
   * @storybook-control select
   */
  activatorSize: {
    type: String,
    default: "default",
    validator: (value) => sizeOptions.includes(value),
  },
  /**
   * Sets a `data-testid` on the default activator button.
   *
   * @type {String}
   * @default undefined
   */
  activatorTestId: {
    type: String,
    default: undefined,
  },
  /**
   * Fade the last visible item under a white gradient while the list is collapsed, hinting that more content is hidden behind the activator.
   *
   * @type {Boolean|String}
   * @default false
   */
  fadeLastItemOnCollapse: booleanAttribute(),
});
